import {configuration} from '../configuration'
import { getProjectConfigurationOdataQuery, getProjectsQuery } from './odataDocumentQueries';

export const getProjectsUrl = (isConfigurationPage?: boolean): string => { 
    const query = getProjectsQuery(isConfigurationPage) as string;
    return `${configuration.api_endpoint}/Projects${(query) ? query : ''}`;
};
export const saveProjectUrl = (): string => { 
    return `${configuration.api_endpoint}/Project`;
};